import loginReducer from './LoginSlice';
import signupReducer from './RegistrationSlice';
import resetPasswordReducer from './ResetPasswordSlice';
import sockerReducer from './SocketSlice';
import changePasswordReducer from './changePasswordSlice';
import forgetPasswordReducer from './forgetPasswordSlice';
import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
  reducer: {
    app: loginReducer,
    app2: signupReducer,
    app3: forgetPasswordReducer,
    app4: resetPasswordReducer,
    app5: changePasswordReducer,
    socket: sockerReducer,
  },
});
